/**
 * Editor-level presentation profile mode (v2.19.0, articles only).
 *
 * 'base' — controls edit base field values (default everywhere; the ONLY mode
 * for non-article documents). 'phone' | 'tablet' | 'laptop' — controls write
 * sparse values to `presentationOverrides.{profile}.*` instead of base paths;
 * base values stay intact. The active profile is a GLOBAL editor mode chosen
 * above the preview, not a per-section setting.
 */

import { createContext, useContext } from 'react';

export type EditorPresentationProfile = 'base' | 'phone' | 'tablet' | 'laptop';

const PresentationProfileContext = createContext<EditorPresentationProfile>('base');

export const PresentationProfileProvider = PresentationProfileContext.Provider;

export function useEditorPresentationProfile(): EditorPresentationProfile {
  return useContext(PresentationProfileContext);
}
